import "jquery";
import _ from "lodash";
import "./gallery.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import "../coffee.main.scss";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Galería";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

let gallery_container = document.createElement("div");
page_template_content.appendChild(gallery_container);

//modal for pictures
let modal = document.createElement("div");
modal.classList.add("modal", "fade");
modal.tabIndex = "-1";
modal.role = "dialog";
modal.id = "js__gallery_images";

page_template_content.appendChild(modal);

let modal_dialog = document.createElement("div");
modal_dialog.classList.add("modal-dialog");

modal.appendChild(modal_dialog);

let modal_content = document.createElement("div");
modal_content.classList.add("modal-content");
modal_dialog.appendChild(modal_content);

let modal_header = document.createElement("div");
modal_header.classList.add("modal-header", "modal_header");
modal_header.id = "modal_header";
let close_button = document.createElement("input");
close_button.style.backgroundColor = "white";
close_button.value = "X";
close_button.classList.add("text-right");
close_button.setAttribute("type", "button");
close_button.setAttribute("data-bs-dismiss", "modal");

modal_header.appendChild(close_button);

let modal_body = document.createElement("div");
modal_body.classList.add("modal-body");
modal_body.id = "modal_body";

modal_content.appendChild(modal_header);
modal_content.appendChild(modal_body);

//prepare to show gallery

let carousel_container = document.createElement("div");
carousel_container.id = "js__modal_carousel_container";
carousel_container.classList.add("carousel", "slide");
carousel_container.setAttribute("data-bs-ride", "carousel");

let carousel_container_inner = document.createElement("div");
carousel_container_inner.classList.add("carousel-inner");

carousel_container.appendChild(carousel_container_inner);
modal_body.appendChild(carousel_container);

let carousel_control_prev = document.createElement("button");
carousel_control_prev.classList.add("carousel-control-prev");
carousel_control_prev.type = "button";
carousel_control_prev.setAttribute(
  "data-bs-target",
  "#js__modal_carousel_container"
);
carousel_control_prev.setAttribute("data-bs-slide", "prev");
let carousel_control_prev_span_icon = document.createElement("span");
carousel_control_prev_span_icon.classList.add("carousel-control-prev-icon");
carousel_control_prev_span_icon.setAttribute("aria-hidden", "true");
let carousel_control_prev_span_text = document.createElement("span");
carousel_control_prev_span_text.classList.add("visually-hidden");
carousel_control_prev_span_text.innerText = "Anterior";
carousel_control_prev.appendChild(carousel_control_prev_span_icon);
carousel_control_prev.appendChild(carousel_control_prev_span_text);

let carousel_control_next = document.createElement("button");
carousel_control_next.classList.add("carousel-control-next");
carousel_control_next.type = "button";
carousel_control_next.setAttribute(
  "data-bs-target",
  "#js__modal_carousel_container"
);
carousel_control_next.setAttribute("data-bs-slide", "next");

let carousel_control_next_span_icon = document.createElement("span");
carousel_control_next_span_icon.classList.add("carousel-control-next-icon");
carousel_control_next_span_icon.setAttribute("aria-hidden", "true");

let carousel_control_next_span_text = document.createElement("span");
carousel_control_next_span_text.classList.add("visually-hidden");
carousel_control_next_span_text.innerText = "Siguiente";
carousel_control_next.appendChild(carousel_control_next_span_icon);
carousel_control_next.appendChild(carousel_control_next_span_text);
carousel_container.appendChild(carousel_control_prev);
carousel_container.appendChild(carousel_control_next);

showImages(gallery_container, modal, carousel_container_inner);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
// $(window).on("load", function () {
page_template.hideLoader();
// });

//********* page functions start ******/

async function showImages(gallery_container, modal, modal_body_carousel) {
  await getGalleries().then((response) => {
    // in each gallery set title and date, show the pictures and close a row
    response.items.forEach(function (item, i) {
      let image_container = document.createElement("div");
      image_container.classList.add("row", "clearfix");

      let title = document.createElement("span");
      title.innerText = item.name;
      title.classList.add("news_type_2_title");

      let line = document.createElement("hr");
      line.classList.add("gallery_title_line");

      let date = document.createElement("span");
      date.innerHTML = "";

      image_container.appendChild(title);
      image_container.appendChild(line);
      image_container.appendChild(date);

      // for each item.images show the pictures
      item.images.reverse().forEach((item) => {
        imgCard(item, image_container, modal, modal_body_carousel);
      });
      gallery_container.appendChild(image_container);
    });
    if (response.items.length == 0) {
      let no_images = document.createElement("div");
      no_images.classList.add("row", "clearfix");
      no_images.innerHTML = "No hay imágenes para mostrar";
      gallery_container.appendChild(no_images);
    }
  });
}

async function showModal(img_url, modal, modal_body_carousel) {
  modal_body_carousel.innerHTML = "";

  let carousel_item = document.createElement("div");
  let img = document.createElement("img");
  img.src = base_url + img_url;
  img.classList.add("carousel_img", "d-block", "w-100");
  carousel_item.appendChild(img);
  modal_body_carousel.appendChild(carousel_item);

  //get the pictures of a specific gallery and show them in the modal
  // await getGallery(id_gallery).then((result) => {
  //   let first = true;
  //   result.item.images.forEach((item) => {
  //     let carousel_item = document.createElement("div");
  //     if (first == true) {
  //       carousel_item.classList.add("carousel-item","active");
  //       first = false;
  //     } else {
  //       carousel_item.classList.add("carousel-item");
  //     }
  //     let img = document.createElement("img");
  //     img.src = base_url + item.image.full_url_image;
  //     img.classList.add('carousel_img', "d-block", "w-100");
  //     carousel_item.appendChild(img);
  //     modal_body_carousel.appendChild(carousel_item);
  //   });
  // });
}

function imgCard(data, div_element, modal, modal_body_carousel) {
  let image_row = document.createElement("div");
  image_row.classList.add("col-sm-6", "col-md-3", "col-lg-3", "news_type_2");
  image_row.setAttribute("data-bs-toggle", "modal");
  image_row.setAttribute("data-bs-target", "#js__gallery_images");

  let img = document.createElement("img");
  img.src = base_url + data.image.full_url_image;

  image_row.appendChild(img);

  div_element.appendChild(image_row);

  image_row.addEventListener(
    "click",
    (e) => {
      e.preventDefault();
      showModal(data.image.full_url_image, modal, modal_body_carousel);
    },
    true
  );
}

//ajax calls
async function getGalleries() {
  let today = new Date(new Date().getFullYear(), 0, 1);
  // 2015-11-22 18:52:40
  // var ajax_data = {
  //   "this_year" : today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate() + " " + "00:00:00"
  // };

  var ajax_data = {
    id_category: 240
  };
  return $.ajax({
    type: "POST",
    url: base_url + "/media/galleries/all",
    data: ajax_data
  });
}

async function getGallery(id) {
  var ajax_data = {
    id: id
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/media/galleries/single",
    data: ajax_data
  });
}
